import { DataFieldType } from '@/app/[locale]/admin/lib/DataFieldType';
import { DataField } from '@/components/data/dataType';

export const formInfo: DataField[] = [
    {
        name: 'name',
        title: { fr: 'Nom', en: 'Name' },
        dataType: DataFieldType.String,
        required: true,
        gridClass: 'col-span-full',
        i18n: false,
        defaultValue: '',
    },
    {
        name: 'title',
        title: { fr: 'Titre', en: 'Title' },
        dataType: DataFieldType.String,
        required: true,
        gridClass: 'col-span-full',
        i18n: true,
        defaultValue: '',
    },
    {
        name: 'sender',
        title: { fr: 'Expéditeur', en: 'Sender' },
        dataType: DataFieldType.String,
        required: true,
        gridClass: 'col-span-full',
        i18n: false,
        defaultValue: '',
    },
    {
        name: 'recipient',
        title: { fr: 'Destinataire', en: 'Recipient' },
        dataType: DataFieldType.String,
        required: true,
        gridClass: 'col-span-full',
        i18n: false,
        defaultValue: '',
    },
    {
        name: 'subject',
        title: { fr: 'Sujet', en: 'Subject' },
        dataType: DataFieldType.String,
        required: true,
        gridClass: 'col-span-full',
        i18n: true,
        defaultValue: '',
    },
    {
        name: 'emailBody',
        title: { fr: 'Corps du mail', en: 'Email Body' },
        dataType: DataFieldType.String,
        required: true,
        gridClass: 'col-span-full',
        i18n: true,
        defaultValue: '',
    },
    {
        name: 'consentRequired',
        title: { fr: 'Consentement requis', en: 'Required consent' },
        dataType: DataFieldType.Boolean,
        required: false,
        gridClass: 'col-span-full',
        i18n: false,
        defaultValue: '',
    },
    {
        name: 'className',
        title: { fr: 'Classe CSS', en: 'CSS Class' },
        dataType: DataFieldType.String,
        required: false,
        gridClass: 'col-span-full',
        i18n: false,
        defaultValue: '',
    },
];
